var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectImage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["image"], 
[], 
function (l_image, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("image", l_image);
var t_2 = "";t_2 += "<div class=\"Project-img Project-img--";
t_2 += runtime.suppressValue(runtime.memberLookup((l_image),"size"), env.opts.autoescape);
t_2 += "\">\n        <div class=\"Project-imgPadding\">\n            <div class=\"Project-imgInner u-Preload u-Cover\">\n                <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_image),"img")),"main"), env.opts.autoescape);
t_2 += "\"\n                     srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_image),"img")),"main_2x"), env.opts.autoescape);
t_2 += " 2x\"\n                     alt=\"Изображение проекта\">\n            </div>\n        </div>\n    </div>\n    ";
t_2 += runtime.suppressValue((lineno = 10, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_2 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("ProjectImage");
context.setVariable("ProjectImage", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectImage.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Project/ProjectImage.jinja
// module id = 68
// module chunks = 0